import React from 'react';
import { Typography, Box, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const ReadTimeInfo = () => {
    const theme = useTheme();

    return (
        <>
            <Typography variant="body1" fontWeight={500} sx={{ pb: 0.5 }}>Read Time Recording</Typography>
            <Typography variant="body2" color={theme.palette.text.secondary}>Read times are recorded between 0 and 20 seconds. Not all email readers support read time reporting.</Typography>
            <Stack direction="row" spacing={3} sx={{ pt: 1 }}>
                <Box>
                    <Typography variant="body2" fontWeight={500} sx={{ pb: 0.5 }}>Supported</Typography>
                    <Typography variant="body2" color={theme.palette.text.secondary}>Microsoft Outlook Mobile App</Typography>
                    <Typography variant="body2" color={theme.palette.text.secondary}>Microsoft Outlook Desktop App</Typography>
                </Box>
                <Box>
                    <Typography variant="body2" fontWeight={500} sx={{ pb: 0.5 }}>Partial Support</Typography>
                    <Typography variant="body2" color={theme.palette.text.secondary}>Outlook 365</Typography>
                </Box>
            </Stack>
        </>
    );
};

export default ReadTimeInfo;